import {
  Autocomplete,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { FormikErrors } from "formik";
import { useEffect, useState } from "react";
import { PlanTemplateWorkout, PlanWorkout } from "@readyfit-common/models";
import { useGetWorkoutLibraryQuery } from "src/store/reducers/training/trainingApiSlice";
import { WorkoutFormValues } from "../EditWorkoutModal/EditWorkoutModal";
import useStyles from "./AddFromLibraryForm.style";

interface AddFromLibraryFormProps {
  values: WorkoutFormValues;
  errors: FormikErrors<WorkoutFormValues>;
  handleChange: any;
  setFieldValue: any;
  resetForm: any;
}

const AddFromLibraryForm = ({
  values,
  errors,
  handleChange,
  setFieldValue,
  resetForm,
}: AddFromLibraryFormProps) => {
  const classes = useStyles();
  const { data: workoutLibrary } = useGetWorkoutLibraryQuery();
  const [selectedWorkout, setSelectedWorkout] = useState<
    PlanWorkout | PlanTemplateWorkout | null
  >(null);

  const handleWorkoutChange = (
    event: React.SyntheticEvent<Element, Event>,
    workout: PlanWorkout | PlanTemplateWorkout | null,
  ) => {
    if (!workout) return;
    setSelectedWorkout(workout);
    setFieldValue("description", workout.description);
    setFieldValue("workoutLibraryId", workout.id);
    // Update all form values based on the selected workout
  };

  useEffect(() => {
    return () => {
      resetForm();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container rowGap={3}>
      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Workout</Typography>
        </InputLabel>
        <Autocomplete
          disablePortal
          options={workoutLibrary?.data?.workouts || []}
          fullWidth
          getOptionLabel={(option) => option.name || ""}
          onChange={handleWorkoutChange}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search workouts..."
              InputProps={{
                ...params.InputProps,
                className: classes.input,
              }}
            />
          )}
        />
      </Grid>

      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Description</Typography>
        </InputLabel>
        <TextField
          disabled
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          value={selectedWorkout && values.description}
          placeholder="Description"
          error={!!errors.description}
          helperText={errors.description}
          InputProps={{
            className: classes.input,
          }}
          onChange={(e) =>
            handleChange("description")(
              e as React.ChangeEvent<HTMLInputElement>,
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default AddFromLibraryForm;
